import cartReducer from './cartReducer';

const rootReducer = {
    cart: cartReducer,
};

export default rootReducer;